/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-09 09:58:42
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-15 16:02:07
 */
import React from 'react'


export default class Iframe extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            url: ''
        };
    }

    componentDidMount() {
        const currentUrl = window.location.href;
        const currentUrlParams = new URLSearchParams(currentUrl.split('?')[1] || '');
        const currentId = currentUrlParams.get('id'); // 从当前页面获取 id

        const specialPrefix = '/lxyweb/kjweb/';
        const isSpecialUrl = this.props.url.startsWith(specialPrefix); // 判断是否为特殊 URL

        let finalUrl = this.props.url;

        // 仅处理特殊前缀的 URL
        if (isSpecialUrl) {
            // 拆分基础路径和查询参数
            const [baseUrl, queryString] = this.props.url.split('?');
            const params = new URLSearchParams(queryString || '');

            // 移除所有现有 id 参数（保留 token 等）
            params.delete('id');

            // 重建无 id 的 URL
            finalUrl = baseUrl + (params.toString() ? `?${params.toString()}` : '');

            // 添加当前页面的 id（若有）
            if (currentId) {
                finalUrl += (params.toString() ? '&' : '?') + `id=${currentId}`;
            }
        }
        // 非特殊 URL：不修改 props.url，直接使用

        this.setState({ url: finalUrl });
        console.log('Iframedd - Final URL:', finalUrl);
    }


    render() {
        let props = this.props.location
        // let path=props.pathname.substring(8)
        return <>
            {/* <Header4></Header4> */}

            <iframe
                title={"344343"}
                style={this.props.blank ? {
                    width: '100%',
                    height: '100vh',
                    position: 'absolute',
                    zIndex: 0
                } : {width: '100%', height: 'calc(100vh - 64px)', position: 'absolute', zIndex: 0}}
                // sandbox="allow-scripts allow-forms allow-same-origin"
                // sandbox="allow-downloads allow-top-navigation allow-forms allow-scripts allow-popups allow-same-origin"
                // sandbox="allow-same-origin"
                // sandbox="allow-top-navigation"
                // src={`${this.props.url}?token=${getCookie("token")}`}>
                // src={`${this.props.url}`}>
                src={`${this.state.url}`}>
            </iframe>
        </>
    }
}